import { PageShell } from '../../ui/PageShell';
import { SettingsGroupCard, SettingsNavItem } from '../settings/settings-shared';

export function AnalysesHomePage() {
  return (
    <PageShell title="Анализы">
      <SettingsGroupCard title="Типы анализа">
        <SettingsNavItem
          title="Анализ SKU"
          subTitle="Один артикул, период FBO"
          to="/analyses/sku"
        />
        <SettingsNavItem title="Поставки" subTitle="Скоро" disabled />
        <SettingsNavItem title="Закупки" subTitle="Скоро" disabled />
        <SettingsNavItem
          title="Дайджест"
          subTitle="Что изменилось по FBO"
          to="/analyses/digest"
        />
        <SettingsNavItem title="Продажи" subTitle="Скоро" disabled isLast />
      </SettingsGroupCard>
    </PageShell>
  );
}
